import
React, {
  useState,
  useContext
} from 'react';

import {
  getCustomerOTP,
  submitOrderdForNewCustomer,
  submitLead
} from 'src/Services/Services';

import SendOTP from 'src/Common/Images/send-otp.png';

import CellPhoneIcon from 'src/Components/Common/Svg/CellPhoneIcon';

import {
  SalesContext
} from 'src/Context/SalesContext';

import PrimaryButton from 'src/Common/Components/PrimaryButton/PrimaryButton';

import {
  Colors
} from 'src/Common/Colors';

import {
  SubmitLeadRequestError, VettingLeftArrow
} from 'src/Components/Common';

import {
  OTP
} from 'src/Components/Common';

import './CustomerApproval.css';

const CustomerApprovalNewCustomer = (props) => {

  const [ showOTP, setShowOTP ] = useState(false);
  const [ hasError, setHasError ] = useState(false);
  const [ formSubmitAttempt, setFormSubmitAttempt ] = useState(0);
  const [ message, setMessage ] = useState('');
  const [ isOtpAttemptFail, setIsOtpAttemptFail ] = useState(false);
  const [ isOtpBlocked, setIsOtpBlocked ] = useState(false);
  const context = useContext(SalesContext);
  const agentUsername = sessionStorage.getItem('retailUserDetails') ? JSON.parse(sessionStorage.getItem('retailUserDetails')).username : null;

  const requestOTP = () => {

    context.setShowSpinner(true);

    getCustomerOTP(agentUsername, context)
      .then(res => {

        context.setShowSpinner(false);

        if (res.ok && res.result?.message) {

          setMessage(res.result?.message);
          setShowOTP(true);
        }
      })
      .catch(error => {

        context.setShowSpinner(false);

        if (error?.response?.status === 423) {

          setIsOtpBlocked(true);
          setShowOTP(true);
        }
      });

  };

  const openCallmeBackPopup = () => {

    context.setShowCallMeBack(true);
  };

  const onCloseOTP = () => {

    setShowOTP(false);
  };

  const closeError = () => {

    setHasError(false);
  };

  const submitLeadIfOrderFailed = () => {

    submitLead(context)
      .then((res) => {

        context.setUserDetails({
          key: 'referenceNo',
          value: res.result && res.result.referenceNumber
        });

        window.scrollTo(0, 0);
        props.history.push('/cloud/fibre/sales/leadConfirmation');
        context.setShowSpinner(false);
      })
      .catch((error) => {

        console.error('[Quotation][submitSalesOrder][submitSalesOrder-Failed]');
        console.error(error);

        context.setShowSpinner(false);

        if (error?.response?.status === 422) {

          setIsOtpAttemptFail(true);

          return;
        }

        if (error?.response?.status === 423) {

          setIsOtpBlocked(true);
          setShowOTP(true);

          return;
        }

        if (formSubmitAttempt < 3) {

          setHasError(true);
          setFormSubmitAttempt(formSubmitAttempt + 1);
        } else {

          setHasError(false);
          context.setNewCustomerErrorObject(error);
          window.scrollTo(0, 0);
          props.history.push('/cloud/fibre/sales/error');
        }
      });
  };

  const submitOTP = (otpValue) => {

    onCloseOTP();

    setHasError(false);

    if (formSubmitAttempt > 3) {

      window.scrollTo(0, 0);
      props.history.push('/cloud/fibre/sales/error');

      return;
    }

    context.setShowSpinner(true);
    setFormSubmitAttempt(formSubmitAttempt + 1);

    submitOrderdForNewCustomer(context, agentUsername, otpValue)
      .then((_response) => {

        context.setShowSpinner(false);
        props.history && props.history.push('/cloud/fibre/sales/success');
      })
      .catch((error) => {

        context.setShowSpinner(false);

        if (error?.response?.status === 422) {

          setIsOtpAttemptFail(true);

          return;
        }

        if (error?.response?.status === 423) {

          setIsOtpBlocked(true);
          setShowOTP(true);

          return;
        }

        if (formSubmitAttempt < 3) {

          setHasError(true);
        } else {

          setHasError(false);
          submitLeadIfOrderFailed();
        }
      });
  };

  const warningMsgOnclick = () => {

    setIsOtpAttemptFail(false);
  };

  const navigateBack = () => {

    props.history.goBack();
  };

  return (

    <div className="customer-approval-main">

      <div className="customer-approval-logo">

        <div className="customer-approval-back" onClick={navigateBack}>
          <div className="customer-approval-back-arrow">
            <VettingLeftArrow />
          </div>
          <span className="customer-approval-back-title">
            Back
          </span>
        </div>

        <img src={SendOTP} className='send-otp-logo' />
      </div>

      <div className="customer-approval-content-container">

        <div className="customer-approval-content-main">

          <div className="customer-approval-content">

            <div>
              <p className="customer-approval-content-heading">Nearly there...</p>

              <p className="customer-approval-content-text">
                To complete this transaction, the customer needs to first approve:
              </p>

              <ol className="customer-approval-content-list">

                <li className="customer-approval-content-list-item">
                  Click the <b>&apos;Send OTP now&apos;</b> button
                </li>

                <li className="customer-approval-content-list-item">
                  Customer receives their one-time-pin (OTP) via email and SMS
                </li>

                <li className="customer-approval-content-list-item">Enter the number they give you to continue</li>
              </ol>

            </div>

            <div className="customer-approval-content-actions">

              <PrimaryButton
                buttonText="Send OTP now"
                onClick={requestOTP}
                isEnabled={true}
                width={'50%'}
                color={Colors.White}
                borderRadius={'68px'}
                fontWeight={'700'}
                showIcon={false} />

              <PrimaryButton
                buttonText="Request a call back"
                onClick={openCallmeBackPopup}
                isEnabled={true}
                activeBackgroundColor={Colors.White}
                width={'50%'}
                color={Colors.Black}
                margin={'0 8px 0 0'}
                borderRadius={'68px'}
                border={'solid'}
                fontWeight={'700'}
                showIcon={true}
                iconSize={'24px'}
                icon={CellPhoneIcon} />

            </div>

          </div>

        </div>

      </div>

      { showOTP &&

        <OTP
          close={onCloseOTP}
          onResendOtp={requestOTP}
          onSubmit={submitOTP}
          otpLength={6}
          showError={isOtpAttemptFail}
          isAccountBlocked={isOtpBlocked}
          warningMsgOnclick={warningMsgOnclick}
          message={message} />

      }

      { hasError &&

        <SubmitLeadRequestError close={closeError} reSubmit={submitOTP} />
      }

    </div>
  );
};

export default CustomerApprovalNewCustomer;